import carbonBadge from '@/assets/images/carbon-simulation/carbon-badge.png'
import carbonForest from '@/assets/images/carbon-simulation/carbon-forest.png'
import carbonTreeMoney from '@/assets/images/carbon-simulation/carbon-tree-money.png'

interface GenerationCreditCarbonProps {
  creditsGeneratedPerHa: string
  creditsGenerated: string
}

export function GenerationCreditCarbon({
  creditsGenerated,
  creditsGeneratedPerHa,
}: GenerationCreditCarbonProps) {
  return (
    <div className="relative order-2 col-span-6 flex h-full flex-col gap-10 rounded-2xl bg-linear-to-t from-bios-darkGreen-200 to-bios-darkGreen-100 px-6 py-20 shadow-2xl lg:order-4 lg:col-span-2 lg:px-10 2xl:w-116">
      <h1 className="text-3xl text-white lg:max-w-96 2xl:text-4xl">
        Geração de créditos de carbono
      </h1>

      <img
        src={carbonBadge}
        className="absolute -right-7 -top-8 size-28"
        alt=""
      />

      <div className="flex flex-col gap-8 *:flex *:flex-col *:items-center *:justify-center *:gap-8 lg:*:flex-row 2xl:*:gap-12">
        <div>
          <img
            className="w-3/5 lg:max-w-28 2xl:max-w-40"
            src={carbonForest}
            alt=""
          />

          <div className="w-full space-y-2 text-center lg:space-y-0 lg:text-start">
            <p className="text-white">
              Créditos de carbono gerado por hectare /ano
            </p>

            <p className="text-3xl font-bold text-monochromatic-200 2xl:text-5xl">
              {creditsGeneratedPerHa}
            </p>

            <p className="text-bios-primary">tCO₂e/ha/ano</p>
          </div>
        </div>

        <div>
          <img
            className="w-3/5 lg:max-w-28 2xl:max-w-40"
            src={carbonTreeMoney}
            alt=""
          />

          <div className="w-full space-y-2 text-center lg:space-y-0 lg:text-start">
            <p className="text-white">
              Créditos de carbono totais gerados no projeto - ROI /ano
            </p>

            <p className="text-3xl font-bold text-monochromatic-200 2xl:text-5xl">
              {creditsGenerated}
            </p>

            <p className="text-bios-primary">tCO₂e/ano</p>
          </div>
        </div>
      </div>
    </div>
  )
}
